import React, {Component} from "react"
import { Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton, Button, VStack, Spacer, Link, Text, Divider, HStack, Image, Box, Icon } from "@chakra-ui/react"
import { AddIcon, TimeIcon, ViewIcon, ChatIcon, QuestionIcon, SettingsIcon, EmailIcon } from '@chakra-ui/icons'
import { FiLogOut } from 'react-icons/fi'
import colors from '../../../theme/colors'

// Dashboard icon component
const DashboardIcon = (props) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
    />
  </svg>
)

class MobileMenu extends Component {
  // Common button props for mobile menu - light design
  getButtonProps = () => ({
    size: "md",
    variant: "ghost",
    color: colors.sidebar.text,
    fontWeight: "600",
    fontSize: "sm",
    borderRadius: "lg",
    py: 4,
    px: 4,
    h: "48px",
    borderLeft: "3px solid transparent",
    transition: "all 0.2s",
    _hover: {
      bg: colors.sidebar.hover,
      color: colors.sidebar.textHover,
      borderLeftColor: colors.sidebar.activeBorder,
      transform: 'translateX(2px)',
    },
    _active: {
      bg: colors.sidebar.active,
      transform: 'translateX(0px)'
    },
    width: "100%",
    justifyContent: "flex-start"
  })

  handleNavigation = (route) => {
    this.props.onRouteChange(route)
    this.props.onClose() // Close drawer after navigation
  }

  handleLogout = () => {
    this.props.onClose() // Close drawer first
    if (this.props.onLogout) {
      this.props.onLogout()
    }
  }

  render() {
    const { isOpen, onClose, userVersion, resetSuggestionsPage } = this.props
    const buttonProps = this.getButtonProps()

    return (
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        closeOnOverlayClick={true}
        closeOnEsc={true}
        blockScrollOnMount={true}
        preserveScrollBarGap={true}
      >
        <DrawerOverlay />
        <DrawerContent bg={colors.sidebar.background}>
          <DrawerCloseButton color={colors.sidebar.text} />
          <DrawerHeader borderBottomWidth="1px" borderColor={colors.sidebar.divider}>
            <HStack spacing={3}>
              <Box p={2} borderRadius="lg" bg={colors.sidebar.logoBg} boxShadow="sm">
                <Image src="/volt_logo.png" boxSize={6} alt="Demos Platform Logo" />
              </Box>
              <Box>
                <Text fontSize="xl" fontWeight="700" color={colors.sidebar.text} letterSpacing="-0.025em">
                  Demos
                </Text>
                <Text fontSize="xs" color={colors.primary.main} fontWeight="600" textTransform="uppercase" letterSpacing="0.1em">
                  Platform
                </Text>
              </Box>
            </HStack>
          </DrawerHeader>

          <DrawerBody p={4}>
            <VStack spacing={2} align="stretch" flex="1">
              {userVersion === 'guest' ? (
                <>
                  <Button
                    {...buttonProps}
                    leftIcon={<AddIcon />}
                    onClick={() => this.handleNavigation('indienen')}
                  >
                    Indienen
                  </Button>

                  <Spacer />

                  <Button
                    {...buttonProps}
                    leftIcon={<Icon as={FiLogOut} />}
                    onClick={this.handleLogout}
                    colorScheme="red"
                    variant="ghost"
                    _hover={{
                      bg: 'rgba(254, 178, 178, 0.2)',
                      color: 'red.300',
                      borderColor: 'rgba(254, 178, 178, 0.3)',
                      transform: 'translateY(-1px)',
                      boxShadow: 'sm'
                    }}
                  >
                    Uitloggen
                  </Button>
                </>
              ) : userVersion === 'burger' ? (
                <>
                  <Button
                    {...buttonProps}
                    leftIcon={<AddIcon />}
                    onClick={() => this.handleNavigation('suggestieIndienen')}
                  >
                    Indienen
                  </Button>
                  <Button
                    {...buttonProps}
                    leftIcon={<TimeIcon />}
                    onClick={() => {
                      if (resetSuggestionsPage) {
                        resetSuggestionsPage()
                      }
                      this.handleNavigation('ingediendeSuggesties')
                    }}
                  >
                    Historie
                  </Button>
                  <Button
                    {...buttonProps}
                    leftIcon={<EmailIcon />}
                    onClick={() => this.handleNavigation('berichten')}
                  >
                    Berichten
                  </Button>

                  <Spacer />

                  <Button
                    {...buttonProps}
                    leftIcon={<SettingsIcon />}
                    onClick={() => this.handleNavigation('instellingen')}
                  >
                    Instellingen
                  </Button>
                  <Button
                    {...buttonProps}
                    leftIcon={<Icon as={FiLogOut} />}
                    onClick={this.handleLogout}
                    colorScheme="red"
                    variant="ghost"
                    _hover={{
                      bg: 'rgba(254, 178, 178, 0.2)',
                      color: 'red.300',
                      borderColor: 'rgba(254, 178, 178, 0.3)',
                      transform: 'translateY(-1px)',
                      boxShadow: 'sm'
                    }}
                  >
                    Uitloggen
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    {...buttonProps}
                    leftIcon={<DashboardIcon style={{ width: '1em', height: '1em' }} />}
                    onClick={() => this.handleNavigation('dashboard')}
                  >
                    Dashboard
                  </Button>
                  <Button
                    {...buttonProps}
                    leftIcon={<ViewIcon />}
                    onClick={() => this.handleNavigation('overzicht')}
                  >
                    Analyse
                  </Button>
                  <Button
                    {...buttonProps}
                    leftIcon={<ChatIcon />}
                    onClick={() => this.handleNavigation('alleSuggesties')}
                  >
                    Suggesties
                  </Button>
                  <Button
                    {...buttonProps}
                    leftIcon={<EmailIcon />}
                    onClick={() => this.handleNavigation('berichten')}
                  >
                    Berichten
                  </Button>

                  <Spacer />

                  <Button
                    {...buttonProps}
                    leftIcon={<SettingsIcon />}
                    onClick={() => this.handleNavigation('instellingen')}
                  >
                    Instellingen
                  </Button>
                  <Button
                    {...buttonProps}
                    leftIcon={<Icon as={FiLogOut} />}
                    onClick={this.handleLogout}
                    colorScheme="red"
                    variant="ghost"
                    _hover={{
                      bg: 'rgba(254, 178, 178, 0.2)',
                      color: 'red.300',
                      borderColor: 'rgba(254, 178, 178, 0.3)',
                      transform: 'translateY(-1px)',
                      boxShadow: 'sm'
                    }}
                  >
                    Uitloggen
                  </Button>
                </>
              )}
            </VStack>

            {/* Support Section */}
            <Box mt="auto" pt={4}>
              <Divider borderColor={colors.sidebar.border} mb={3} />

              <Link href="mailto:support@metdemos.app" isExternal>
                <Button
                  leftIcon={<QuestionIcon />}
                  size="sm"
                  variant="outline"
                  fontWeight="500"
                  fontSize="xs"
                  borderRadius="lg"
                  h="40px"
                  borderColor="rgba(255, 255, 255, 0.3)"
                  color={colors.sidebar.text}
                  transition="all 0.2s"
                  _hover={{
                    bg: colors.sidebar.hover,
                    borderColor: 'rgba(255, 255, 255, 0.5)',
                    color: colors.sidebar.text
                  }}
                  width="100%"
                  justifyContent="center"
                >
                  Hulp nodig?
                </Button>
              </Link>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    )
  }
}

export default MobileMenu
